import { ReactNode, Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from './core/Button';
import { DialogWindow } from './Dialog';

interface WarningDialogProps {
  content?: ReactNode;
  onCancel: () => void;
  open?: boolean;
  onOpenChange?: Dispatch<SetStateAction<boolean>>;
  title: string;
  dialogTrigger?: ReactNode;
  buttonText: string;
  buttonIcon?: ReactNode;
  onConfirm: () => void;
  loading?: boolean;
}

export const WarningDialog = ({
  title,
  content,
  open,
  onOpenChange,
  onCancel,
  buttonText,
  buttonIcon,
  onConfirm,
  dialogTrigger,
  loading,
}: WarningDialogProps) => {
  return (
    <DialogWindow
      title={title}
      content={
        <div className="flex flex-col gap-4">
          {content ? <div>{content}</div> : null}
          <div className="mt-4 flex justify-end gap-2">
            <Button variant="ghost" onClick={onCancel}>
              <FormattedMessage defaultMessage="Avbryt" />
            </Button>
            <Button
              variant="filled"
              color="red"
              onClick={onConfirm}
              loading={loading}
              startIcon={buttonIcon}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      }
      onOpenChange={(newState) => {
        onCancel();
        onOpenChange?.(newState);
      }}
      open={open}
      dialogTrigger={dialogTrigger}
    />
  );
};
